/* Various utilities */
export const GameUtils = () => {

}



/** WEBPACK FOOTER **
 ** src/util.js
 **/